<app-modal class="app-profile-config-modal" *ngIf="vo$ | async ; let vo">
	<div modal-body class="app-profile-config-modal__body">
		<dc-alert
			class="info"
			type="info"
			message="info"
			i18n-message="@@subscription.profile.config.modal.description">
		</dc-alert>

		<app-profile-config
			[mode]="'STANDALONE'"
			[profileConfig]="vo.profileConfig"
			[availableColumns]="vo.availableColumns"
			(forStepChange)="changeStep($event)"></app-profile-config>
	</div>


	<div class="app-profile-config-modal__footer" modal-footer>
		<div
			*ngIf="vo.error"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			id="{{ cmpId }}-save-btn"
			[disabled]="vo.criticErrorCount !== 0"
			[color]="'primary'"
			(click)="vo.action === ProfileConfigAction.Create? createAction() :  updateAction()"
			mat-raised-button>
			<span
				*ngIf="vo.action === ProfileConfigAction.Create"
				i18n="@@general.action.save">
				save</span>

			<span
				*ngIf="vo.action === ProfileConfigAction.Update"
				i18n="@@general.action.update">
				update</span>
		</button>
	</div>
</app-modal>
